import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home';
import { ServicesComponent } from './features/services/services';
import { TeamComponent } from './features/team/team';
import { BookingComponent } from './features/booking/booking';
import { PortalComponent } from './features/portal/portal';
import { AboutComponent } from './features/about/about';
import { PrivacyComponent } from './features/privacy/privacy';
import { AnalyticsComponent } from './features/analytics/analytics';
import { AffiliatesJoinComponent } from './features/affiliates/affiliates-join';
import { AffiliatesLoginComponent } from './features/affiliates/affiliates-login';
import { AffiliatesDashboardComponent } from './features/affiliates/affiliates-dashboard';
import { AffiliatesTermsComponent } from './features/affiliates/affiliates-terms';
import { SeniorIndependenceComponent } from './features/senior-independence/senior-independence';
import { affiliateAuthGuard } from './core/guards/affiliate-auth.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'senior-independence', component: SeniorIndependenceComponent },
  { path: 'senior-care', redirectTo: 'senior-independence', pathMatch: 'full' },
  { path: 'team', component: TeamComponent },
  { path: 'book', component: BookingComponent },
  { path: 'booking', redirectTo: 'book', pathMatch: 'full' },
  { path: 'portal', component: PortalComponent },
  { path: 'analytics', component: AnalyticsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'affiliates', redirectTo: 'affiliates/join', pathMatch: 'full' },
  { path: 'affiliates/join', component: AffiliatesJoinComponent },
  { path: 'affiliates/login', component: AffiliatesLoginComponent },
  { path: 'affiliates/terms', component: AffiliatesTermsComponent },
  { path: 'affiliates/dashboard', component: AffiliatesDashboardComponent, canActivate: [affiliateAuthGuard] },
  { path: '**', redirectTo: '' }
];
